const useTitle = title => {
    document.title = `Dream Shop - ${title}`
}


export default useTitle;